// extracted by mini-css-extract-plugin
export default {"parent":"Works_parent__StDKR","text":"Works_text__2Gdus","container":"Works_container__p5VdN"};